import React, {Component} from 'react';
import { Modal, Icon } from 'antd';

class ModalCustom extends Component {
    render() {
        return (
            <div>
                <Modal
                    title={null}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                    closable={false}
                    width={this.props.width}
                    wrapClassName="modal-wrap"
                >
                    <div className="modal-header-wrap">
                        <div className="is-row">
                            <div className={`is-column is-50 path-wrap ${this.props.showPath ? '' : 'hidden'}`}>{this.props.showPath}</div>
                            <div className="is-column is-50 close-modal-wrap">
                                <div className="close-modal" onClick={this.props.onCancel}>
                                    <Icon type="close" className="close-modal-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-header-title">{this.props.title}</div>
                    </div>
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}

export default ModalCustom;
